var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("\n        "+_vm._s(_vm.setTime(_vm.data[_vm.fieldKey], 'DD-MM-YYYY : HH:mm:ss'))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }